import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from './config';

// Get view statistics for a profile
export function useGetViewStats(profileId) {
  return useQuery({
    queryKey: ['view-stats', profileId],
    queryFn: async () => {
      const response = await axiosInstance.get(`users/profiles/view-stats/${profileId}/`);
      return response.data;
    },
    enabled: !!profileId,
  });
}

// Get profile with view count
export function useGetProfileWithViews(profileId) {
  return useQuery({
    queryKey: ['profile-with-views', profileId],
    queryFn: async () => {
      const response = await axiosInstance.get(`users/profiles/${profileId}/`);
      return response.data;
    },
    enabled: !!profileId,
  });
}















